import { render, staticRenderFns } from "./GamePath.vue?vue&type=template&id=a34c400e&scoped=true&"
import script from "./GamePath.vue?vue&type=script&lang=js&"
export * from "./GamePath.vue?vue&type=script&lang=js&"
import style0 from "./GamePath.vue?vue&type=style&index=0&id=a34c400e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34c400e",
  null
  
)

export default component.exports